import { render, staticRenderFns } from "./PaymentVerify.vue?vue&type=template&id=52e5dce4&scoped=true&"
import script from "./PaymentVerify.vue?vue&type=script&lang=js&"
export * from "./PaymentVerify.vue?vue&type=script&lang=js&"
import style0 from "./PaymentVerify.vue?vue&type=style&index=0&id=52e5dce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5dce4",
  null
  
)

export default component.exports